import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhSideBarComponent } from './components/fh-side-bar.component';
import { SidebarModule } from 'primeng/sidebar';
import { Route, RouterModule } from '@angular/router';
import { FhSideBarHeaderComponent } from './components/childs/fh-side-bar-header.component';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FhButtonModule } from '@fh-client-interaction-frontends/fh-button';

const userControlPanelRoutes: Route[] = [];
@NgModule({
  imports: [CommonModule, RouterModule.forChild(userControlPanelRoutes), SidebarModule, TooltipModule, TranslateModule, FhButtonModule],
  declarations: [FhSideBarComponent, FhSideBarHeaderComponent],
  exports: [FhSideBarComponent, FhSideBarHeaderComponent, RouterModule]
})
export class FhSideBarModule {}
